export const NAV_LINKS = [
  { name: 'A Associação', href: '#quem-somos' },
  { name: 'Comissão', href: '#diretoria' },
  { name: 'Municípios', href: '#municipios' },
  { name: 'Ações', href: '#acoes' },
  { name: 'Contato', href: '#contato' },
];

export const INSTITUTIONAL_INFO = {
  name: 'ACONTURS Litoral',
  fullTitle: 'Associação dos Conselheiros e Ex-Conselheiros Tutelares do RS - Regional Litoral',
  description: 'Comissão Provisória da Região Litoral, unindo os municípios integrantes do COREDE Litoral em prol da valorização e capacitação contínua.',
  mission: 'Representar oficialmente a ACONTURS perante os municípios da Região Litoral, observando os princípios estatutários de fortalecimento da rede de proteção.',
  vision: 'Ser a referência de articulação política e técnica para os Conselhos Tutelares do Litoral Norte.',
  appLink: '/app/login'
};

export const APP_LINKS = {
  android: '#',
  ios: '#',
  web: '#',
  features: [
    {
      title: 'Carteirinha Digital',
      desc: 'Sua identificação oficial de associado sempre com você.',
      icon: 'fas fa-id-card'
    },
    {
      title: 'Mapa da Rede',
      desc: 'Contatos e endereços atualizados de todos os Conselhos do litoral.',
      icon: 'fas fa-map-marked-alt'
    },
    {
      title: 'Ouvidoria Direta',
      desc: 'Canal exclusivo para enviar demandas e reclamações à diretoria.',
      icon: 'fas fa-bullhorn'
    },
    {
      title: 'Agenda de Cursos',
      desc: 'Inscreva-se em capacitações e eventos com um clique.',
      icon: 'fas fa-calendar-check'
    }
  ]
};

// Dados dinâmicos (Municípios, Eventos, Diretoria, Patrocinadores, Cronograma)
// migrados para o banco de dados e acessados via API + hooks em src/hooks/.
